/**
 * @generated SignedSource<<08ae633ca3744e011ebeb9ef5643eb1d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type recordsGetRecordQuery$variables = {
  hash: string;
};
export type recordsGetRecordQuery$data = {
  readonly GetRecord: {
    readonly hash: string;
    readonly registeredAt: any;
  };
};
export type recordsGetRecordQuery = {
  response: recordsGetRecordQuery$data;
  variables: recordsGetRecordQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "hash"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "hash",
    "variableName": "hash"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hash",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "registeredAt",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "recordsGetRecordQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Record",
        "kind": "LinkedField",
        "name": "GetRecord",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "recordsGetRecordQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Record",
        "kind": "LinkedField",
        "name": "GetRecord",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "19e249381be552cddd1bdeb6bb829135",
    "id": null,
    "metadata": {},
    "name": "recordsGetRecordQuery",
    "operationKind": "query",
    "text": "query recordsGetRecordQuery(\n  $hash: String!\n) {\n  GetRecord(hash: $hash) {\n    hash\n    registeredAt\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "47e9c03b429c7dfaef070351a2466487";

export default node;
